import { useEffect, useState } from "react";
import { Box } from "theme-ui";

import axios from "axios";

// Will load an SVG file to embed, allowing CSS to change the `fill` colour,
// which is not possible using the <img/> tag
export default function Svg({ src, sx = {}, ...props }) {
  const [svgElement, setSvgElement] = useState(null);

  useEffect(() => {
    axios.get(src).then(({ data }) => {
      setSvgElement(data);
    });
  }, [src]);

  return (
    <Box
      dangerouslySetInnerHTML={{ __html: svgElement }}
      sx={{
        svg: {
          height: "100%",
        },
        "svg,path": {
          fill: "inherit",
        },
        ...sx,
      }}
      {...props}
    />
  );
}
